export const classTypes = {
  ON_DEMAND_VIDEO: 1,
  EXTRA_RESOURCE: 2,
  TASK: 3,
  LIVE_WORKSHOP: 4,
  TITLE: 5,
};

export const classTypeNames = {
  [classTypes.ON_DEMAND_VIDEO]: 'On-demand video',
  [classTypes.EXTRA_RESOURCE]: 'Extra resource',
  [classTypes.TASK]: 'Task',
  [classTypes.LIVE_WORKSHOP]: 'Live Workshop',
  [classTypes.TITLE]: 'Title',
};
